/* eslint-disable no-param-reassign */
import config from '../../config';
import getResizeDirection from '../../common/getResizeDirection';
import sameConversatonMethod from '../../common/sameConversaton';
import isCanceled from '../../common/isCanceled';
import debounce from '../../utils/debounce';
import getLocaleMixins from '../../utils/getLocaleMixins';
import MessageType from '../../utils/MessageType';
import dateFormat from '../../utils/dateFormat';
import isEmpty from '../../utils/isEmpty';
import isEmojiOverlap from '../../utils/isEmojiOverlap';
import browserWindow from '../../browserWindow';
import client from '../../client';
import system from '../../system';
import getLatestMessage from './latest-message.vue';
import avatar from '../avatar.vue';
import getSearch from '../search.vue';
import getContextMenuMixins from '../mixins/context-menu';
import getGroupName from '../../common/getGroupName';

// 会话列表每页加载个数
const pageNum = config.conversationList.pageNum;


export default {
    name: 'conversation-list',
    mixins: [getLocaleMixins('conversation-list'), getContextMenu()],
    data() {
        const im = this.$im();
        const params = im.$route.params;
        return {
            busy: true,
            auth: im.auth,
            conversation: {
                conversationType: params.conversationType,
                targetId: params.targetId,
            },
            list: [],
            hasMore: true,
            listBusy: {},
            bound: {
                width: {
                    min: 0,
                    max: 0,
                },
            },
            isResizing: false,
            // 当前会话列表最后一条的索引值
            lastIndex: 0,
            loadingNextPage: false,
            isFirst: true,
        };
    },
    mounted() {
        const conversationList = this;
        const im = this.$im();
        const conversationAPI = im.dataModel.Conversation;
        const common = this.RongIM.common;
        // 收到消息时更新会话列表,延时500ms,页面平滑过渡 （最后一条消息，未读数）
        const messagechanged = debounce(() => {
            pageRefresh(conversationList);
        }, 500);
        im.$on('messagechange', messagechanged);
        // 会话列表改变时更新到页面。
        conversationList.watch = function watch(list) {
            pageRefresh(conversationList, list);
        };
        // 监听会话列表改变
        conversationAPI.watch(conversationList.watch);
        // 初始化会话列表获取第一页
        conversationList.getInit();
        // 会话列表可拖拽（增加拖拽事件）
        common.resizeNavNode(conversationList, im);
        // 搜索会话跳转时，加载并滚动到指定会话
        im.$on('loadSearch', (index) => {
            index += 1;
            if (index > conversationList.lastIndex) {
                conversationList.lastIndex = index;
                pageRefresh(conversationList);
            }
        });
        // 发送消息时滚动到最 "顶部"
        im.$on('sendMessage', () => {
            scrollToTop($(conversationList.$refs.list));
        });

        // 文件上传时监听同步文件的状态
        im.$on('uploadStatusChange', (message, status) => {
            // 找到消息,改变状态
            const list = conversationList.list;
            for (let i = 0; i < list.length; i += 1) {
                const item = list[i];
                if (item.conversationType === message.conversationType
                        && item.targetId === message.targetId
                ) {
                    const latestMessage = item.latestMessage;
                    if (latestMessage.messageId !== message.messageId) {
                        break;
                    }
                    // TODO: 代码需优化，暂时没找到更好的方法同步会话列表发送状态
                    latestMessage.content.status = status;
                    if (status === 1) {
                        latestMessage.sentStatus = RongIMLib.SentStatus.SENDING;
                    }
                    break;
                }
            }
        });
    },
    created() {
        const conversationList = this;
        const im = this.$im();
        const conversationAPI = im.dataModel.Conversation;
        // 注册 "Ctrl + F" 搜索快捷键事件
        client.regSearch(() => {
            const searchBox = conversationList.$refs.searchBox;
            if (searchBox) {
                searchBox.focus();
            }
        });

        // 设置公众号信息监听
        browserWindow.enterPublic(im.$router, (router, app) => {
            const params = {
                conversationType: RongIMLib.ConversationType.APP_PUBLIC_SERVICE,
                targetId: app.id,
            };
            router.push({
                name: 'conversation',
                params,
            });
            conversationAPI.add(params);
            const itemId = ['conversation', params.conversationType, params.targetId].join('-');
            const item = document.getElementById(itemId);
            if (item) {
                const parentHeight = item.parentNode.offsetHeight;
                const offsetTop = item.offsetTop;
                const alginWithTop = offsetTop > parentHeight;
                item.scrollIntoView(alginWithTop);
            }
        });
    },
    destroyed() {
        const im = this.$im();
        const conversationAPI = im.dataModel.Conversation;
        conversationAPI.unwatch(this.watch);
        // 删除监听 "Ctrl + F" 搜索快捷键事件
        client.unregSearch();
    },
    computed: {
        status() {
            return this.$im().status;
        },
        width() {
            // 会话列表的宽度
            const node = this.$im().resizeNode.rongList;
            return node.width;
        },
        resizeDirection() {
            // 当前可拖动的方向
            return this.$im().resizeDirection.use;
        },
    },
    watch: {
        status() {
            // 页面刷新时等待连接成功再获取会话列表
            this.getInit();
        },
        $route(route) {
            const params = route.params;
            const im = this.$im();
            const common = this.RongIM.common;
            this.conversation = {
                conversationType: params.conversationType,
                targetId: params.targetId,
            };
            // 绑定拖动方法
            common.resizeNavNode(this, im);
        },
    },
    components: {
        search: getSearch,
        'latest-message': getLatestMessage,
        avatar,
    },
    methods: {
        /**
         * 修改会话列表
         * @param {Array} arrConversation 会话列表内容
         */
        setList(arrConversation) {
            const idCount = {};
            // console.debug(`arrConversation.length => ${arrConversation.length}`)
            const tmpList = arrConversation.filter((item) => {
                const id = `conversation-${item.conversationType}-${item.targetId}`;
                idCount[id] = (idCount[id] || 0) + 1;
                const count = idCount[id];
                if (count > 1) {
                    system.appLogger('error', new Error(`multiple conversation id: ${id}`).stack);
                    return false;
                }
                const key = item.conversationType + item.targetId;
                item.viewId = id;
                item.viewKey = key;
                return true;
            });
            this.list = tmpList;
        },
        // 绘制 UI 使用， 获取会话列表最后一条消息时间的字符串在页面渲染的宽度（为保证会话名称最大长度展示）
        getTimeRenderWidth(item) {
            const fontSize = 12;
            const timeString = this.dateFormat(item.latestMessage.sentTime);
            return this.RongIM.common.getTextRenderWidth(timeString, fontSize);
        },
        getHtmlUsername(...args) {
            return this.RongIM.common.getHtmlUsername(...args);
        },
        getHtmlGroupName(...args) {
            return this.RongIM.common.getHtmlGroupName(...args);
        },
        getUsername(...args) {
            return this.RongIM.common.getUsername(...args);
        },
        getGroupUsername(...args) {
            return this.RongIM.common.getGroupUsername(...args);
        },
        getHtmlGroupUsername(...args) {
            return this.RongIM.common.getHtmlGroupUsername(...args);
        },
        getGroupName,
        getGroupType(...args) {
            return this.RongIM.common.getGroupType(...args);
        },
        dateFormat,
        scroll() {
            // 滚动的时候搜索框失去焦点
            this.$im().$emit('searchBlur');
        },
        getInit() {
            // 初始化会话列表，获取第一页
            const conversationList = this;
            const conversationAPI = this.$im().dataModel.Conversation;
            const common = this.RongIM.common;
            if (conversationList.status === RongIMLib.ConnectionStatus.CONNECTED) {
                conversationList.busy = true;
                conversationAPI.getInitList(pageNum, (errorCode, list) => {
                    if (errorCode) {
                        common.toastError(errorCode);
                        return;
                    }
                    // 仅当有数据时再更新会话列表
                    if (list.length > 0) {
                        conversationList.setList(list);
                        conversationList.lastIndex = list.length > pageNum ? list.length : pageNum;
                    }
                    conversationList.busy = false;
                });
            }
        },
        get() {
            const conversationAPI = this.$im().dataModel.Conversation;
            const common = this.RongIM.common;
            const conversationList = this;
            if (conversationList.status === RongIMLib.ConnectionStatus.CONNECTED) {
                conversationList.busy = true;
                conversationAPI.getList((errorCode, list) => {
                    if (errorCode) {
                        common.toastError(errorCode);
                        return;
                    }
                    // 仅当有数据时再更新会话列表
                    if (list.length > 0) {
                        conversationList.allList = list;
                    }
                    if (conversationList.lastIndex === 0) {
                        const totalNum = conversationList.allList.length + 1;
                        conversationList.lastIndex = totalNum > pageNum ? pageNum : totalNum;
                    }
                    conversationList.busy = false;
                });
            }
        },
        // 最后一条消息展示样式
        isRichText(message) {
            if (message.messageType !== 'TextMessage') {
                return false;
            }
            const common = this.RongIM.common;
            const textContent = message.content.content;
            const content = common.convertMessage(textContent);
            return textContent !== content;
        },
        isFailed(message) {
            return message.sentStatus === RongIMLib.SentStatus.FAILED;
        },
        isSending(message) {
            return message.sentStatus === RongIMLib.SentStatus.SENDING;
        },
        isCanceled(message) {
            return isCanceled(message);
        },
        // 是否是无效消息,比如历史消息全部删除后会有一条 messageId=-1 的消息
        isInvalid(message) {
            return message.messageId === -1;
        },
        isPrivate(item) {
            return item.conversationType === 1 || item.conversationType === 7;
        },
        isGroup(item) {
            return item.conversationType === 3;
        },
        isEqual: sameConversaton,
        isShowGroupType(group) {
            return group && +group.type !== 0;
        },
        getMessageType(message) {
            return (message.messageType || '').toLowerCase();
        },
        isFromMe(message) {
            return message.messageDirection === 1;
        },
        getSentStatus(message) {
            const sentStatus = RongIMLib.SentStatus[message.sentStatus] || '';
            return sentStatus.toLowerCase();
        },
        getRecievedStatus(message) {
            const status = RongIMLib.ReceivedStatus[message.receivedStatus] || '';
            return status.toLowerCase();
        },
        // 消息状态 "已读" "未读"
        isOtherRead(message) {
            if (isEmpty(message.sentStatus)) {
                // web 不支持存储消息状态默认置为已读
                message.sentStatus = RongIMLib.SentStatus.READ;
            }
            return message.sentStatus === RongIMLib.SentStatus.READ;
        },
        // 是否显示消息状态："已读" "未读"
        showSentStatus(message, conversation) {
            const isPrivate = this.isPrivate(message);
            const isFromMe = this.isFromMe(message);
            const messageTypes = [
                MessageType.TextMessage,
                MessageType.ImageMessage,
                MessageType.FileMessage,
                MessageType.VoiceMessage,
                MessageType.CardMessage,
                MessageType.LocationMessage,
                MessageType.ReferenceMessage,
            ];
            const existed = messageTypes.indexOf(message.messageType) >= 0;
            const user = conversation.user;
            const isNotFileHelper = user && user.type !== 3;
            const isPublic = message.conversationType === 7;
            return isPrivate && isFromMe && existed && isNotFileHelper && !isPublic;
        },
        top(conversation) {
            const conversationList = this;
            const conversationType = conversation.conversationType;
            const targetId = conversation.targetId;
            const key = `${conversationType}_${targetId}`;
            if (conversationList.listBusy[key]) {
                conversationList.closeContextmenu();
                return;
            }
            conversationList.listBusy[key] = true;
            const conversationAPI = this.$im().dataModel.Conversation;
            conversationAPI.top(conversationType, targetId, () => {
                conversationList.listBusy[key] = false;
            });
            conversationList.closeContextmenu();
        },
        untop(conversation) {
            const conversationType = conversation.conversationType;
            const targetId = conversation.targetId;
            const conversationAPI = this.$im().dataModel.Conversation;
            conversationAPI.untop(conversationType, targetId);
            this.closeContextmenu();
        },
        mute(conversation) {
            const conversationType = conversation.conversationType;
            const targetId = conversation.targetId;
            const conversationAPI = this.$im().dataModel.Conversation;
            conversationAPI.mute(conversationType, targetId);
            this.closeContextmenu();
        },
        unmute(conversation) {
            const conversationType = conversation.conversationType;
            const targetId = conversation.targetId;
            const conversationAPI = this.$im().dataModel.Conversation;
            conversationAPI.unmute(conversationType, targetId);
            this.closeContextmenu();
        },
        remove(conversation) {
            const conversationList = this;
            const conversationType = conversation.conversationType;
            const targetId = conversation.targetId;
            const conversationAPI = this.$im().dataModel.Conversation;
            const removeFuc = function removeFuc() {
                conversationAPI.remove(conversationType, targetId);
                conversationList.closeContextmenu();
                // 删除的是当前会话则跳转到"主页"
                const params = conversationList.$route.params;
                if (sameConversatonMethod(params, conversation)) {
                    conversationList.$router.push({
                        name: 'conversation',
                        query: {
                            force: 1,
                        },
                    });
                }
            };
            removeFuc();
        },
        showConversaton(conversation) {
            const context = this;
            const conversationType = conversation.conversationType;
            const targetId = conversation.targetId;
            const im = this.$im();
            const conversationAPI = im.dataModel.Conversation;
            if (conversation.unreadMessageCount > 0) {
                conversationAPI.clearUnReadCount(conversationType, targetId);
            }
            conversationAPI.getOne(conversationType, targetId, (error, newConversation) => {
                im.$emit('conversationchange', newConversation);
                context.$router.push({
                    name: 'conversation',
                    params: {
                        targetId,
                        conversationType,
                    },
                });
                context.conversation = newConversation;
            });
        },
        convertMessage(...args) {
            return this.RongIM.common.convertMessage(...args);
        },
        isShowName(conversation) {
            return isShowName(this.auth.id, conversation, this);
        },
        // 判断 '@' 消息中是否包含自己
        mentionMsgHasSelf(conversation) {
            const mentionMsg = conversation.mentionedMsg;

            // 判读这条@消息是谁发的如果是自己发的则不显示，暂用有无未读消息
            const hasUnRead = conversation.unreadMessageCount !== 0;
            if ($.isEmptyObject(mentionMsg)) {
                return false;
            }

            if (mentionMsg.mentionedInfo.type === RongIMLib.MentionedType.ALL) {
                return hasUnRead;
            }
            const userIdList = mentionMsg.mentionedInfo.userIdList;
            return userIdList.indexOf(this.$im().auth.id) !== -1 && hasUnRead;
        },
        getId(conversation) {
            const items = ['conversation', conversation.conversationType, conversation.targetId];
            return items.join('-');
        },
        // 文字最后是emoji, 且在mac 非高清屏下, emoji 会被覆盖一部分
        // 原因: chrome对emoji的渲染造成的. 解决: 判断, 加padding-right
        isCoverName(text) {
            const RongIMEmoji = RongIMLib.RongIMEmoji;
            const nativeTagReg = RongIMEmoji.emojiNativeReg;
            const emojis = text ? text.match(nativeTagReg) : text;
            const notIncludeEmoji = !emojis || !emojis.length;
            if (notIncludeEmoji || !isEmojiOverlap()) {
                return false;
            }
            const matchContent = emojis[emojis.length - 1];
            const index = text.lastIndexOf(matchContent);
            return matchContent.length + index === text.length;
        },
        isGroupNameCover(text) {
            const name = this.getGroupName(text);
            return this.isCoverName(name);
        },
        isUserNameCover(text) {
            const name = this.getUsername(text);
            return this.isCoverName(name);
        },
        // 获取拖拽方向
        getResizeDirection() {
            const direction = getResizeDirection({
                range: this.width,
                bound: this.bound.width,
                directions: ['left', 'right'],
            });
            if (this.isResizing) {
                this.$im().resizeDirection.temp = direction;
            }
            return direction;
        },
        loadMore() {
            loadMore(this);
        },
    },
};

/**
会话列表右键菜单
与context-menu.js混合应用
context为showContextmenu()方法中传入的第二个参数
* */
function getContextMenu() {
    const options = {
        template: '#rong-template-conversation-contextmenu',
        computed: {
            isTop() {
                return this.context.conversation.isTop;
            },
            isMute() {
                return this.context.conversation.notificationStatus;
            },
        },
        methods: {
            top() {
                this.$emit('top', this.context.conversation);
            },
            untop() {
                this.$emit('untop', this.context.conversation);
            },
            mute() {
                this.$emit('mute', this.context.conversation);
            },
            unmute() {
                this.$emit('unmute', this.context.conversation);
            },
            remove() {
                this.$emit('remove', this.context.conversation);
            },
            close() {
                this.$emit('close');
            },
        },
    };
    return getContextMenuMixins(options);
}


function sameConversaton(one, another) {
    const oneConversationType = +one.conversationType;
    const anotherConversationType = +another.conversationType;
    const sameConversationType = oneConversationType === anotherConversationType;
    const sameTargetId = one.targetId === another.targetId;
    return sameConversationType && sameTargetId;
}

function isShowName(authId, conversation, context) {
    const groupType = RongIMLib.ConversationType.GROUP;
    const isGroup = conversation.conversationType === groupType;

    // SDK消息未解析 messageType 为 undefined 此处要判断
    let isNotificationMessage = true;
    const notNotificationMessages = [
        'InformationNotificationMessage',
        'JrmfRedPacketOpenedMessage',
        'JrmfRedPacketMessage',
        'GroupMemChangedNotifyMessage',
        'GroupNotifyMessage',
        'GroupCmdMessage',
    ];
    const messageType = conversation.latestMessage.messageType;
    if (!isEmpty(messageType)) {
        isNotificationMessage = notNotificationMessages.indexOf(messageType) !== -1;
    }
    const user = conversation.latestMessage.user || {};
    const isOther = authId !== user.id;
    const username = !isEmpty(context.RongIM.common.getUsername(user));
    const notReCall = messageType !== 'RecallCommandMessage';
    const isShow = isGroup && !isNotificationMessage && isOther && username && notReCall;
    return isShow;
}

function scrollToTop(listContent) {
    listContent.scrollTop(0);
}

// 根据 lastIndex: 显示条数 更新会话列表 isMore: 是否加载更多
function pageRefresh(context, list, isMore) {
    const end = context.lastIndex || pageNum;
    if (list) {
        context.setList(list);
        context.lastIndex = list.length > pageNum ? list.length : pageNum;
        return;
    }
    const common = context.RongIM.common;
    const conversationAPI = context.$im().dataModel.Conversation;
    conversationAPI.getInitList(end, (errorCode, conversationList) => {
        if (errorCode) {
            common.toastError(errorCode);
            return;
        }
        setTimeout(() => {
            context.loadingNextPage = false;
            // 仅当有数据时再更新会话列表
            if (conversationList.length > 0) {
                context.setList(conversationList);
            }
            if (conversationList.length < end && isMore) {
                context.hasMore = false;
            }
        }, 1000);
    });
}

// 分页加载会话列表获取下一页
function loadMore(conversationList) {
    if (!conversationList.isFirst && !conversationList.hasMore) {
        return;
    }
    if (conversationList.loadingNextPage) {
        return;
    }
    conversationList.isFirst = false;
    conversationList.loadingNextPage = true;
    const end = conversationList.lastIndex + pageNum;
    conversationList.lastIndex = end;
    pageRefresh(conversationList, null, true);
}
